import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface NutzungsbedingungenPageProps {
  onBack: () => void;
}
export function NutzungsbedingungenPage({
  onBack
}: NutzungsbedingungenPageProps) {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-503">
      <div className="max-w-3xl mx-auto" data-id="element-504">
        <button onClick={onBack} className="flex items-center text-slate-500 hover:text-brand-500 transition-colors mb-8 group" data-id="element-505">
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-506" />
          Zurück zur Startseite
        </button>

        <h1 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-8" data-id="element-507">
          Nutzungsbedingungen
        </h1>

        <div className="prose prose-slate max-w-none text-slate-600" data-id="element-508">
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-509">
            1. Geltungsbereich
          </h2>
          <p data-id="element-510">
            Diese Nutzungsbedingungen gelten für die Nutzung der Website
            uronacht.de (nachfolgend „Website"), betrieben von der Nuviora UG
            (haftungsbeschränkt) Cosimastraße 121 München, 81925 Deutschland
            (nachfolgend „wir" oder „Betreiber").
          </p>
          <p data-id="element-511">
            Mit dem Zugriff auf und der Nutzung dieser Website erklären Sie sich
            mit diesen Nutzungsbedingungen einverstanden. Wenn Sie mit diesen
            Bedingungen nicht einverstanden sind, bitten wir Sie, die Website
            nicht zu nutzen.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-512">
            2. Leistungsbeschreibung
          </h2>
          <p data-id="element-513">
            Die Website dient der Information über das Nahrungsergänzungsmittel
            UroNacht sowie dem Vertrieb dieses Produkts. Wir bemühen uns, die
            Inhalte aktuell und korrekt zu halten, übernehmen jedoch keine
            Gewähr für die Vollständigkeit, Richtigkeit und Aktualität der
            bereitgestellten Informationen.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-514">
            3. Geistiges Eigentum
          </h2>
          <p data-id="element-515">
            Alle Inhalte dieser Website — einschließlich Texte, Bilder,
            Grafiken, Logos, Marken und Software — sind urheberrechtlich
            geschützt und Eigentum der Nuviora UG (haftungsbeschränkt) oder
            ihrer Lizenzgeber. Eine Vervielfältigung, Verbreitung oder sonstige
            Nutzung dieser Inhalte ohne ausdrückliche schriftliche Genehmigung
            ist untersagt.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-516">
            4. Haftungsausschluss
          </h2>
          <p data-id="element-517">
            Die auf dieser Website bereitgestellten Informationen dienen
            ausschließlich der allgemeinen Information und stellen keine
            medizinische Beratung dar. Nahrungsergänzungsmittel sind kein Ersatz
            für eine ausgewogene Ernährung und gesunde Lebensweise.
          </p>
          <p data-id="element-518">
            Wir haften nicht für Schäden, die durch die Nutzung oder
            Nichtnutzung der auf dieser Website dargebotenen Informationen
            entstehen, sofern nicht Vorsatz oder grobe Fahrlässigkeit vorliegt.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-519">
            5. Links zu externen Websites
          </h2>
          <p data-id="element-520">
            Unsere Website kann Links zu externen Websites Dritter enthalten.
            Auf die Inhalte dieser externen Seiten haben wir keinen Einfluss und
            übernehmen daher keine Gewähr. Für die Inhalte der verlinkten Seiten
            ist stets der jeweilige Anbieter verantwortlich.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-521">
            6. Verfügbarkeit der Website
          </h2>
          <p data-id="element-522">
            Wir bemühen uns, die Website möglichst unterbrechungsfrei zur
            Verfügung zu stellen. Jedoch können wir keine Garantie für die
            ständige Verfügbarkeit übernehmen. Wir behalten uns das Recht vor,
            die Website jederzeit ohne Vorankündigung zu ändern, zu ergänzen
            oder einzustellen.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-523">
            7. Änderungen der Nutzungsbedingungen
          </h2>
          <p data-id="element-524">
            Wir behalten uns vor, diese Nutzungsbedingungen jederzeit zu ändern.
            Die jeweils aktuelle Fassung ist auf dieser Seite einsehbar. Durch
            die fortgesetzte Nutzung der Website nach Änderungen stimmen Sie den
            geänderten Bedingungen zu.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-525">
            8. Anwendbares Recht
          </h2>
          <p data-id="element-526">
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss
            des UN-Kaufrechts. Gerichtsstand ist Berlin, soweit gesetzlich
            zulässig.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-527">
            9. Kontakt
          </h2>
          <p data-id="element-528">
            Bei Fragen zu diesen Nutzungsbedingungen wenden Sie sich bitte an:
            Nuviora UG (haftungsbeschränkt) Cosimastraße 121 München, 81925
            Deutschland
          </p>
        </div>
      </div>
    </div>;
}